import styled, { css } from 'styled-components';
import React from 'react';
import { basicColor, boxShadow, radius } from '@/styles/template';
import Grid from '@/components/molecules/Grid';

export const Wrap = styled.div`
	background: ${props => props.theme.color.Background};
  	border-radius: ${radius.large};
  	padding: 4rem 3rem;
  	color: ${props => props.theme.color.Text};

	${({ color }) => color && css`
		background: ${color};
	`}
`;

interface Props {
	children: React.ReactNode;
	centered?: boolean;
	color?: string;
}

const Card: React.FC<Props> = ({ children, centered, color }) => {
	return (
		<Wrap color={color}>
			<Grid col='1' gap='2' centeredContent={centered} centeredText={centered}>
				{children}
			</Grid>
		</Wrap>
	);
};

export default Card;